// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__H2HDD","spinner-y0fdc1":"Spinner_spinner-y0fdc1__R92H2"};